import React from "react";

const Pagination = ({ totalRapports, perPage, setCurrentPage, currentPage }) => {
    let pages = [];
    const totalPages = Math.ceil(totalRapports / perPage);

    for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
    }

    const goToPage = (page) => {
        setCurrentPage(page);
    }

    const goToPreviousPage = () => {
        setCurrentPage(currentPage - 1);
    }

    const goToNextPage = () => {
        setCurrentPage(currentPage + 1);
    }

    return (
        <nav>
            <ul className="pagination justify-content-center">
                <li className={currentPage === 1 ? "page-item disabled" : "page-item"}>
                    <button className="page-link" onClick={goToPreviousPage}>Précédent</button>
                </li>
                {
                    pages.map((page, index) => {
                        return (
                            <li className={page === currentPage ? "page-item active" : "page-item"} key={index}>
                                <button className="page-link" onClick={() => goToPage(page)}>{page}</button>
                            </li>
                        )
                    })
                }
                <li className={currentPage === totalPages ? "page-item disabled" : "page-item"}>
                    <button className="page-link" onClick={goToNextPage}>Suivant</button>
                </li>
            </ul>
        </nav>
    );
}

export default Pagination;
